import { createContext, ReactNode, useState } from "react";

// Définition du type Resultats
type Resultats = {
    hebergement: any;
    resto: any;
    voiture: any;
    loisire: any;
    culture: any;
};

// Définition du type pour le contexte, incluant les résultats et la fonction de mise à jour
type ResultContextType = {
    results: Resultats;
    updateResults: (newResults: Resultats) => void;
};

// Création du contexte avec le type approprié
export const ResultContext = createContext<ResultContextType | undefined>(undefined);

// Provider qui gère l'état des résultats
export const ResultProvider = ({children}:{children: ReactNode}) => {
    const [results, setResults] = useState<Resultats>({
        hebergement: null,
        resto: null,
        voiture: null,
        loisire: null,
        culture: null,
    });

    // Fonction pour mettre à jour les résultats
    const updateResults = (newResults: Resultats) => {
        setResults(newResults);
    };

    return (
        <ResultContext.Provider value={{ results, updateResults }}>
            {children}
        </ResultContext.Provider>
    );
};
